// removed by extract-text-webpack-plugin
module.exports = {"root":"_7msrh","layout":"_hHFwJ","left":"_2IssF","title":"_bxIol","desc":"_OqTPh"};


//////////////////
// WEBPACK FOOTER
// ./app/containers/Post/components/PostContent/components/ContentBlock/components/SocialMedia/components/LikeBlock/components/LoginDialog/white.scss
// module id = 1181
// module chunks = 2